import styled from 'styled-components';

const SettingStyled = styled.div`
  .coupons-setting-button {
    width: 108px;
  }
  .coupons-setting-button-reset {
    background-color: #666464;
  }
  .coupon-button-wrap {
    .loading-button {
      color: #fff;
      background-color: ${(props) => props.theme.palette.primary.main};
    }
  }
  input::placeholder {
    color: #c9c9c9;
  }
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
  .coupons-setting-button-up {
    background-color: #666464;
  }
  .coupons-setting-button-up:hover {
    background-color: #212121;
  }
  .next-button-icon {
    transform: rotateY(180deg);
  }
  .coupons-setting-button-exit {
    background-color: #666464;
    color: #ffffff;
  }
  .coupons-setting-button-exit:hover {
    background-color: #212121;
  }
`;
export default SettingStyled;
